import { jsx as b, jsxs as f } from "react/jsx-runtime";
import { useMemo as m } from "react";
const v = ({
  nativeListPrice: c,
  nativeSpotPrice: e,
  skuSpecifications: s,
  unitMultiplier: a,
  hasPromotionalPrice: l,
  defaultScListPrice: i
}) => {
  const { listPrice: n, spotPrice: o } = l ?? {}, P = (r, t) => m(() => {
    const g = (r - t) * 100 / r;
    return Math.round(g);
  }, [t, r]), { listPriceCustom: d, spotPriceCustom: h } = m(() => n && o && o !== e ? {
    listPriceCustom: n,
    spotPriceCustom: o
  } : {
    listPriceCustom: c,
    spotPriceCustom: e
  }, [
    n,
    o,
    e,
    c
  ]), p = "Venda por unidade", C = s == null ? void 0 : s.some((r) => r.field.originalName === p && r.values.some((t) => t.originalName === "true")), N = i ?? (C ? d : ((r) => Number(r.toString().match(/^\d+(?:\.\d{0,2})?/)))(d * a)), u = Math.round(
    Number(P(N, h))
  );
  return !u || u <= 0 ? null : /* @__PURE__ */ b("div", { className: "product-card-discount-badge", children: /* @__PURE__ */ f("p", { className: "product-card-discount-badge-value", children: [
    u,
    "%"
  ] }) });
};
export {
  v as ProductCardDiscountBadge
};
